<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "dtsRating",
  data() {
    return {
      submitted: false,
      mouseOver5: false,
      mouseOver4: false,
      mouseOver3: false,
      mouseOver2: false,
      mouseOver1: false,
      form: {
        trackId: null,
        deliveryUnitId: null,
        rate: null,
        comments: "",
      },
    };
  },
  validations: {
    form: {
      rate: { required },
    },
  },
  methods: {
    setRating(trackId, deliveryUnitId) {
      this.submitted = false;
      this.form.rate = null;
      this.form.comments = "";
      this.form.trackId = trackId;
      this.form.deliveryUnitId = deliveryUnitId;
      this.$bvModal.show("modal-trackRating");
    },
    onSubmit() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.$store
        .dispatch("dtsRating/CreateTrackRating", this.form)
        .then((res) => {
          this.$emit("saveRating", this.form.trackId);
          this.$bvModal.hide("modal-trackRating");
          this.showToast("Successfully submitted", "success");
        })
        .catch((err) => {
          this.showToast("Something went wrong - Submitting Rating!", "error");
        });
    },
  },
};
</script>
      
<template>
  <b-modal
    id="modal-trackRating"
    title="Track Rating"
    size="md"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <div class="mb-3">
      <label for="description">Rate </label>
      <div
        class="px-4 br-5 border"
        :class="{
          'border-danger': submitted && $v.form.rate.$error,
        }"
        style="background-color: #2e3446"
      >
        <div class="row align-items-center" style="min-height: 80px">
          <div class="col">
            <div
              @mouseenter="mouseOver5 = true"
              @mouseleave="mouseOver5 = false"
              class="text-center cursor-pointer rating emoticon"
              :class="{
                'selectedRate': form.rate == 5,
                'bx-tada': mouseOver5 == true && form.rate != 5,
              }"
              @click="form.rate = 5"
            >
              <i class="mdi mdi-emoticon-excited"></i>
            </div>
          </div>
          <div class="col">
            <div
              @mouseenter="mouseOver4 = true"
              @mouseleave="mouseOver4 = false"
              class="text-center cursor-pointer rating emoticon"
              :class="{
                'selectedRate': form.rate == 4,
                'bx-tada': mouseOver4 == true && form.rate != 4,
              }"
              @click="form.rate = 4"
            >
              <i class="mdi mdi-emoticon-happy"></i>
            </div>
          </div>
          <div class="col">
            <div
              @mouseenter="mouseOver3 = true"
              @mouseleave="mouseOver3 = false"
              class="text-center cursor-pointer rating emoticon"
              :class="{
                'selectedRate': form.rate == 3,
                'bx-tada': mouseOver3 == true && form.rate != 3,
              }"
              @click="form.rate = 3"
            >
              <i class="mdi mdi-emoticon-neutral"></i>
            </div>
          </div>
          <div class="col">
            <div
              @mouseenter="mouseOver2 = true"
              @mouseleave="mouseOver2 = false"
              class="text-center cursor-pointer rating emoticon"
              :class="{
                'selectedRate': form.rate == 2,
                'bx-tada': mouseOver2 == true && form.rate != 2,
              }"
              @click="form.rate = 2"
            >
              <i class="mdi mdi-emoticon-sad"></i>
            </div>
          </div>
          <div class="col">
            <div
              @mouseenter="mouseOver1 = true"
              @mouseleave="mouseOver1 = false"
              class="text-center cursor-pointer rating emoticon-angry"
              :class="{
                'selectedRate': form.rate == 1,
                'bx-tada': mouseOver1 == true && form.rate != 1,
              }"
              @click="form.rate = 1"
            >
              <i class="mdi mdi-emoticon-angry"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <label for="description">Comment </label>
      <textarea
        id="comments"
        rows="4"
        v-model="form.comments"
        placeholder="Enter comments..."
        class="form-control"
        autocomplete="off"
      ></textarea>
    </div>

    <div class="d-flex flex-row-reverse mb-2">
      <button class="btn btn-primary mt-3" @click="onSubmit()">Submit</button>
    </div>
  </b-modal>
</template>

<style>
.selectedRate {
  font-size: 50px !important;
}
.rating {
  font-size: 35px;
}
.emoticon {
  background-image: linear-gradient(#ff9f43 60%, #ff9e4387) !important;
  background-clip: text;
  color: transparent;
}
.emoticon-angry {
  background-image: linear-gradient(#ff8843, #ff2a00 60%) !important;
  background-clip: text;
  color: transparent;
}
</style>